import {adminAxios} from '@/Plugins/Axios';

// COO delivery-speed dashboard. A warehouse that is not ready answers 503 with
// `reason`; the page words that itself (see reasonOf).
export async function fetchDeliverySpeedSummary(params = {}) {
    const response = await adminAxios.get('report/delivery-speed/summary', {params});
    return response.data.data;
}

export async function fetchDeliverySpeedSlowBills(params = {}) {
    const response = await adminAxios.get('report/delivery-speed/slow-bills', {params});
    return response.data.data;
}

export function reasonOf(error) {
    const reason = error && error.response && error.response.data && error.response.data.reason;
    return ['warehouse_not_configured', 'mart_empty', 'warehouse_error'].includes(reason) ? reason : 'generic';
}
